module.exports = __webpack_public_path__ + "static/images/grabpay.3f0tFud.svg";